import instance from "../axios";

export const verify = async (partnerID, tableCode) => {
  const response = await instance.get(
    "tables/Verify.php?partnerID=" + partnerID + "&tableCode=" + tableCode
  );

  return response.data;
};
